import BackButton from "@/components/nav/BackButton";
import React from "react";
import { NavLink } from "react-router-dom";

type PlaceType = {
  title: string;
  subTitle: string;
  dates: string;
  link: string;
  thumbnail: string;
  logo: string;
  demographic: string;
  city: string;
  place: string;
  placeLink: string;
  country: string;
};

const EventCalendar = () => {
  const localEvents: Array<PlaceType> = [
    {
      title: "QUARTERfashion",
      subTitle: "Fachmesse und Ordertage für Bekleidung und Accessoires",
      dates: "05. - 07. August 2023",
      link: "https://www.messeninfo.de/QUARTERfashion-M4827/Schkeuditz.html",
      thumbnail: "/images/info/events/small_344.webp",
      logo: "/images/info/events/midora_logo_224.webp",
      demographic: "für Fachbesucher",
      place: "MMC Mitteldeutsches Mode Center, Schkeuditz",
      placeLink:
        "https://www.messeninfo.de/MMC+Mitteldeutsches+Mode+Center-ZS518.html",
      city: "Leipzig",
      country: "Deutschland",
    },
    {
      title: "QUARTERshoestart",
      subTitle: "Mitteldeutsche Schuhmesse und Ordertage",
      dates: "11. - 13. August 2023",
      link: "https://www.messeninfo.de/QUARTERshoestart-M1615/Schkeuditz.html",
      thumbnail: "/images/info/events/small_307.webp",
      logo: "/images/info/events/quartershoestart_logo_1615.webp",
      demographic: "für Fachbesucher",
      place: "MMC Mitteldeutsches Mode Center, Schkeuditz",
      placeLink:
        "https://www.messeninfo.de/MMC+Mitteldeutsches+Mode+Center-ZS518.html",
      city: "Zwickau",
      country: "Deutschland",
    },
    {
      title: "QUARTERdessous",
      subTitle: "Fachmesse für Unterwäsche und Dessous",
      dates: "11. - 13. August 2023",
      link: "https://www.messeninfo.de/QUARTERdessous-M11799/Schkeuditz.html",
      thumbnail: "/images/info/events/small_86.webp",
      logo: "/images/info/events/quarterdessous_logo_11799.webp",
      demographic: "für Fachbesucher",
      place: "MMC Mitteldeutsches Mode Center, Schkeuditz",
      placeLink:
        "https://www.messeninfo.de/MMC+Mitteldeutsches+Mode+Center-ZS518.html",
      city: "Leipzig",
      country: "Deutschland",
    },
    {
      title: "handgemacht Kreativmarkt & StoWoMa",
      subTitle:
        "Die große Verkaufsschau für Individualisten, Designer und Selbermacher",
      dates: "27. August 2023",
      link: "https://www.messeninfo.de/handgemacht+Kreativmarkt+%26+StoWoMa+Open+Air-M12458/Dresden.html",
      thumbnail: "/images/info/events/small_206.webp",
      logo: "/images/info/events/handgemacht_kreativ_markt_stowoma_logo_12458.webp",
      demographic: "Publikumsveranstaltung",
      place: "Galopprennbahn Dresden-Seidnitz, Dresden",
      placeLink:
        "https://www.messeninfo.de/Galopprennbahn+Dresden-Seidnitz-ZS10419.html",
      city: "Leipzig",
      country: "Deutschland",
    },
    {
      title: "Midora",
      subTitle: "Order- und Informationsmesse der Uhren- und Schmuckbranche",
      dates: "02. - 04. September 2023",
      link: "https://www.messeninfo.de/Midora-M224/Leipzig.html",
      thumbnail: "/images/info/events/small_344.webp",
      logo: "/images/info/events/midora_logo_224.png",
      demographic: "für Fachbesucher",
      place: "Messe Leipzig",
      placeLink: "https://www.messeninfo.de/Messe+Leipzig-ZS18.html",
      city: "Leipzig",
      country: "Deutschland",
    },
    {
      title: "Modellbahnbörse",
      subTitle:
        "Messe für Modellbahnen, Autos, und Ü-Eier-Figuren in der Stadthalle in Zwickau",
      dates: "02. September 2023",
      link: "https://www.messeninfo.de/Modellbahnb%C3%B6rse-M11979/Zwickau.html",
      thumbnail: "/images/info/events/small_249.webp",
      logo: "/images/info/events/modellbahnboerse_logo_11979.webp",
      demographic: "Publikumsmesse",
      place: "Stadthalle",
      placeLink: "https://www.messeninfo.de/Stadthalle-ZS2656.html",
      city: "Zwickau",
      country: "Deutschland",
    },
    {
      title: "Cadeaux",
      subTitle: "Fachmesse für Geschenk- und Wohntrends",
      dates: "02. - 04. September 2023",
      link: "https://www.messeninfo.de/Cadeaux-M221/Leipzig.html",
      thumbnail: "/images/info/events/small_249.webp",
      logo: "/images/info/events/cadeaux_logo_221.webp",
      demographic: "für Fachbesucher",
      place: "Messe Leipzig",
      placeLink: "https://www.messeninfo.de/Messe+Leipzig-ZS18.html",
      city: "Leipzig",
      country: "Deutschland",
    },
    {
      title: "unique 4+1",
      subTitle:
        "Internationale Fachmesse für Trophies, Gravier- und Werbetechnik",
      dates: "02. - 04. September 2023",
      link: "https://www.messeninfo.de/unique+4%2B1-M5165/Leipzig.html",
      thumbnail: "/images/info/events/small_366.webp",
      logo: "/images/info/events/unique_logo_5165.webp",
      demographic: "für Fachbesucher und Privatbesucher",
      place: "Messe Leipzig",
      placeLink: "https://www.messeninfo.de/Messe+Leipzig-ZS18.html",
      city: "Leipzig",
      country: "Deutschland",
    },
    {
      title: "Terra-Rep",
      subTitle: "Die Reptilien-Fachmesse für jung und alt",
      dates: "03. September 2023",
      link: "https://www.messeninfo.de/Terra-Rep-M13588/Oelsnitz%2C+Vogtland.html",
      thumbnail: "/images/info/events/small_297.webp",
      logo: "/images/info/events/terrarep_logo_13588.webp",
      demographic: "für Fachbesucher und Privatbesucher",
      place: "Vogtlandsporthalle",
      placeLink: "https://www.messeninfo.de/Vogtlandsporthalle-ZS10071.html",
      city: "Oelsnitz, Vogtland",
      country: "Deutschland",
    },
    {
      title: "Modellbahnbörse",
      subTitle:
        "Messe für Modellbahnen, Autos, und Ü-Eier-Figuren in der Stadthalle in Zwickau",
      dates: "03. September 2023",
      link: "https://www.messeninfo.de/Modellbahnb%C3%B6rse-M1022/Dresden.html",
      thumbnail: "/images/info/events/small_249.webp",
      logo: "/images/info/events/modellbahnboerse_logo_11979.webp",
      demographic: "Publikumsmesse",
      place: "Alte Mensa",
      placeLink: "https://www.messeninfo.de/Alte+Mensa-ZS861.html",
      city: "Dresden",
      country: "Deutschland",
    },
    {
      title: "LebensArt",
      subTitle:
        "Messe für Garten, Wohnen und Lifestyle auf dem Wernesgrüner Brauerei-Gutshof",
      dates: "08. - 10. September 2023",
      link: "https://www.messeninfo.de/LebensArt-M12582/Steinberg.html",
      thumbnail: "/images/info/events/small_135.webp",
      logo: "/images/info/events/lebensart_logo_neu_12582.webp",
      demographic: "Publikumsmesse",
      place: "Wernesgrüner Brauerei-Gutshof, Steinberg",
      placeLink:
        "https://www.messeninfo.de/Wernesgr%C3%BCner+Brauerei-Gutshof-ZS9247.html",
      city: "Steinberg",
      country: "Deutschland",
    },
    {
      title: "QUARTERshoetime & bags Orderdays",
      subTitle: "Mitteldeutsche Messe für Schuhe und Lederwaren",
      dates: "08. - 10. September 2023",
      link: "https://www.messeninfo.de/QUARTERshoetime+%26+bags+Orderdays-M650/Schkeuditz.html",
      thumbnail: "/images/info/events/small_307.webp",
      logo: "/images/info/events/quartershoetime_logo_650.webp",
      demographic: "für Fachbesucher",
      place: "MMC Mitteldeutsches Mode Center, Schkeuditz",
      placeLink:
        "https://www.messeninfo.de/MMC+Mitteldeutsches+Mode+Center-ZS518.html",
      city: "Schkeuditz",
      country: "Deutschland",
    },
    {
      title: "Bauen Kaufen Wohnen",
      subTitle: "Dresdner Bau- und Immobilienmesse",
      dates: "09. - 10. September 2023",
      link: "https://www.messeninfo.de/Bauen+Kaufen+Wohnen-M6450/Dresden.html",
      thumbnail: "/images/info/events/small_157.webp",
      logo: "/images/info/events/bauen_kaufen_wohnen_logo_6450.webp",
      demographic: "für Fachbesucher und Privatbesucher",
      place: "Messe Dresden",
      placeLink: "https://www.messeninfo.de/Messe+Dresden-ZS227.html",
      city: "Dresden",
      country: "Deutschland",
    },
    {
      title: "HORIZON Mitteldeutschland",
      subTitle: "Das Event für Orientierung nach dem Abi",
      dates: "09. September 2023",
      link: "https://www.messeninfo.de/HORIZON+Mitteldeutschland-M6897/Schkeuditz.html",
      thumbnail: "/images/info/events/small_364.webp",
      logo: "/images/info/events/horizon_logo_neu_6897.webp",
      demographic: "Publikumsmesse",
      place: "Globana Trade Center Leipzig Halle, Schkeuditz",
      placeLink:
        "https://www.messeninfo.de/Globana+Trade+Center+Leipzig+Halle-ZS4431.html",
      city: "Schkeuditz",
      country: "Deutschland",
    },
    {
      title: "Jobmesse",
      subTitle: "Karrieremesse",
      dates: "09. September 2023",
      link: "https://www.messeninfo.de/Jobmesse-M8087/Leipzig.html",
      thumbnail: "/images/info/events/small_399.webp",
      logo: "/images/info/events/jobmesse_leipzig_logo_neu_8087.webp",
      demographic: "Publikumsmesse",
      place: "Congress Center",
      placeLink: "https://www.messeninfo.de/Congress+Center-ZS1049.html",
      city: "Leipzig",
      country: "Deutschland",
    },
    {
      title: "Modellbahnbörse",
      subTitle:
        "Messe für Modellbahnen, Autos, und Ü-Eier-Figuren in der Festhalle in Plauen",
      dates: "10. September 2023",
      link: "https://www.messeninfo.de/Modellbahnb%C3%B6rse-M1026/Plauen.html",
      thumbnail: "/images/info/events/small_249.webp",
      logo: "/images/info/events/modellbahnboerse_logo_1026.webp",
      demographic: "Publikumsmesse",
      place: "Festhalle",
      placeLink: "https://www.messeninfo.de/Festhalle-ZS865.html",
      city: "Plauen",
      country: "Deutschland",
    },
    {
      title: "efa",
      subTitle: "Fachmesse für Elektro-, Gebäude-, Licht- und Energietechnik",
      dates: "12. - 14. September 2023",
      link: "https://www.messeninfo.de/efa-M3897/Leipzig.html",
      thumbnail: "/images/info/events/small_196.webp",
      logo: "/images/info/events/efa_leipzig_logo_3897.webp",
      demographic: "für Fachbesucher",
      place: "Messe Leipzig",
      placeLink: "https://www.messeninfo.de/Messe+Leipzig-ZS18.html",
      city: "Leipzig",
      country: "Deutschland",
    },
    {
      title: "Jobmesse",
      subTitle:
        "Publikumsmesse mit vielfältigen Angeboten zu den Themen Job, Studium sowie Aus- und Weiterbildung",
      dates: "14. September 2023",
      link: "https://www.messeninfo.de/Jobmesse-M7507/Chemnitz.html",
      thumbnail: "/images/info/events/small_399.webp",
      logo: "/images/info/events/jobmesse_leipzig_logo_neu_8087.webp",
      demographic: "Publikumsmesse",
      place: "Stadion an der Gellertstrasse, Chemnitz",
      placeLink:
        "https://www.messeninfo.de/Stadion+an+der+Gellertstrasse-ZS10431.html",
      city: "Chemnitz",
      country: "Deutschland",
    },
    {
      title: "AZUBI Spot",
      subTitle: "Die Azubi-, Studi- und Karrieremesse im CinemaxX in Dresden",
      dates: "14. September 2023",
      link: "https://www.messeninfo.de/AZUBI+Spot-M4802/Dresden.html",
      thumbnail: "/images/info/events/small_25.webp",
      logo: "/images/info/events/azubisport_logo_neu_4802.webp",
      demographic: "für Fachbesucher und Privatbesucher",
      place: "CinemaxX",
      placeLink: "https://www.messeninfo.de/CinemaxX-ZS10642.html",
      city: "Dresden",
      country: "Deutschland",
    },
    {
      title: "LebensArt",
      subTitle: " Messe für Garten, Wohnen und Lifestyle auf Schloss Brandis",
      dates: "15. - 17. September 2023",
      link: "https://www.messeninfo.de/LebensArt-M5155/Brandis.html",
      thumbnail: "/images/info/events/small_135.webp",
      logo: "/images/info/events/lebensart_logo_neu_5155.webp",
      demographic: "Publikumsmesse",
      place: "Schloss Brandis",
      placeLink: "https://www.messeninfo.de/Schloss+Brandis-ZS9856.html",
      city: "Brandis",
      country: "Deutschland",
    },
  ];

  const largeEvents: Array<PlaceType> = [
    {
      title: "LebensArt",
      subTitle:
        "Messe für Garten, Wohnen und Lifestyle auf der Schlossinsel Lübben",
      dates: "28. - 30. Juli 2023",
      link: "https://www.messeninfo.de/LebensArt-M8205/L%C3%BCbben.html",
      thumbnail: "/images/info/events/small_135.webp",
      logo: "/images/info/events/lebensart_logo_neu_8205.webp",
      demographic: "Publikumsmesse",
      place: "Schloss",
      placeLink: "https://www.messeninfo.de/Schloss-ZS6470.html",
      city: "Lübben",
      country: "Deutschland",
    },
    {
      title: "Haus- & Garten Träume",
      subTitle: "Messe für moderenes Gartenambiente auf Burg Ohrdruf",
      dates: "28. - 30. Juli 2023",
      link: "https://www.messeninfo.de/Haus-+%26+Garten+Tr%C3%A4ume-M1764/Ohrdruf.html",
      thumbnail: "/images/info/events/small_135.webp",
      logo: "/images/info/events/haus_und_gartentraeume_ohrdruf_logo_1764.webp",
      demographic: "Publikumsmesse",
      place: "Burg Ohrdruf",
      placeLink: "https://www.messeninfo.de/Burg+Ohrdruf-ZS1475.html",
      city: "Ohrdruf",
      country: "Deutschland",
    },
    {
      title: "Messen bundesweit",
      subTitle: "Kölns größtes kulinarisches Open-Air-Festival",
      dates: "28. - 30. Juli 2023",
      link: "https://www.messeninfo.de/Gourmet+Festival-M3441/K%C3%B6ln.html",
      thumbnail: "/images/info/events/small_82.webp",
      logo: "/images/info/events/gourmet_festival_logo_neu_3441.webp",
      demographic: "für Fachbesucher und Privatbesucher",
      place: "Schokoladenmuseum",
      placeLink: "https://www.messeninfo.de/Schokoladenmuseum-ZS6249.html",
      city: "Köln",
      country: "Deutschland",
    },
    {
      title: "EinsSein-Messe",
      subTitle:
        "Die Messe für Gesundheit, Spiritualität und Begegnung in den Festsälen der Weser Ems Hallen in Oldenburg",
      dates: "29. - 30. Juli 2023",
      link: "https://www.messeninfo.de/EinsSein-Messe-M4181/Oldenburg.html",
      thumbnail: "/images/info/events/small_102.webp",
      logo: "/images/info/events/einssein_messe_logo_4181.webp",
      demographic: "für Fachbesucher und Privatbesucher",
      place: "Weser-Ems-Hallen",
      placeLink: "https://www.messeninfo.de/Weser-Ems-Hallen-ZS515.html",
      city: "Oldenburg",
      country: "Deutschland",
    },
    {
      title: "INNATEX",
      subTitle: "Internationale Fachmesse für nachhaltige Textilien",
      dates: "29. - 31. Juli 2023",
      link: "https://www.messeninfo.de/INNATEX-M27/Hofheim+am+Taunus.html",
      thumbnail: "/images/info/events/small_335.webp",
      logo: "/images/info/events/innatex_logo_27.webp",
      demographic: "für Fachbesucher",
      place: "Messecenter Rhein-Main, Hofheim am Taunus",
      placeLink: "https://www.messeninfo.de/Messecenter+Rhein-Main-ZS857.html",
      city: "Hofheim am Taunus",
      country: "Deutschland",
    },
    {
      title: "Kunst & HandwerkerMarkt",
      subTitle:
        "Ausstellung für Kunsthandwerk aller Arten und Materialien in der Altstadt",
      dates: "30. Juli 2023",
      link: "https://www.messeninfo.de/Kunst+%26+HandwerkerMarkt-M14128/Leer.html",
      thumbnail: "/images/info/events/small_206.webp",
      logo: "/images/info/events/kunst_und_handwerkermarkt_logo_14128.webp",
      demographic: "Publikumsmesse",
      place: "Rathausstraße",
      placeLink: "https://www.messeninfo.de/Rathausstra%C3%9Fe-ZS10694.html",
      city: "Leer",
      country: "Deutschland",
    },
    {
      title: "Arolser Kram- und Viehmarkt",
      subTitle: "Volksfest und Gewerbeausstellung",
      dates: "03. - 06. August 2023",
      link: "https://www.messeninfo.de/Arolser+Kram-+und+Viehmarkt-M9445/Bad+Arolsen.html",
      thumbnail: "/images/info/events/small_147.webp",
      logo: "/images/info/events/arolser_kram_und_viehmarkt_logo_9445.webp",
      demographic: "Publikumsmesse",
      place: "Festplatz Königsberg",
      placeLink:
        "https://www.messeninfo.de/Festplatz+K%C3%B6nigsberg-ZS7145.html",
      city: "Bad Arolsen",
      country: "Deutschland",
    },
    {
      title: "Das Gartenfest Corvey",
      subTitle: "Gartenausstellung auf Schloss Corvey",
      dates: "04. - 06. August 2023",
      link: "https://www.messeninfo.de/Das+Gartenfest+Corvey-M10875/H%C3%B6xter.html",
      thumbnail: "/images/info/events/small_135.webp",
      logo: "/images/info/events/das_gartenfest_corvey_logo_10875.webp",
      demographic: "Publikumsmesse",
      place: "Schloss Corvey",
      placeLink: "https://www.messeninfo.de/Schloss+Corvey-ZS7913.html",
      city: "Höxter",
      country: "Deutschland",
    },
    {
      title: "Schöner Golfen",
      subTitle:
        "Open Air Ausstellung für Golf, Country und Elektromobilität im Golf & Country Club an der Elfrather Mühle",
      dates: "04. - 06. August 2023",
      link: "https://www.messeninfo.de/Sch%C3%B6ner+Golfen-M13954/Krefeld.html",
      thumbnail: "/images/info/events/small_151.webp",
      logo: "/images/info/events/schoener_golfen_logo_13954.webp",
      demographic: "für Fachbesucher und Privatbesucher",
      place: "Golf & Country Club an der Elfrather Mühle, Krefeld",
      placeLink:
        "https://www.messeninfo.de/Golf+%26+Country+Club+an+der+Elfrather+M%C3%BChle-ZS10539.html",
      city: "Krefeld",
      country: "Deutschland",
    },
    {
      title: "DIGA",
      subTitle: "Die Gartenmesse",
      dates: "04. - 08. August 2023",
      link: "https://www.messeninfo.de/DIGA-M6800/Iffezheim.html",
      thumbnail: "/images/info/events/small_280.webp",
      logo: "/images/info/events/diga_logo_6800.webp",
      demographic: "Publikumsmesse",
      place: "Rennbahn und Parkgelände, Iffezheim",
      placeLink:
        "https://www.messeninfo.de/Rennbahn+und+Parkgel%C3%A4nde-ZS5808.html",
      city: "Iffezheim",
      country: "Deutschland",
    },
    {
      title: "Kindermoden Nord",
      subTitle: "Fachmesse für Kindermode",
      dates: "05. - 07. August 2023",
      link: "https://www.messeninfo.de/Kindermoden+Nord-M11120/Hamburg.html",
      thumbnail: "/images/info/events/small_191.webp",
      logo: "/images/info/events/kindermoden_nord_logo_11120.webp",
      demographic: "für Fachbesucher",
      place: "Messehalle Hamburg-Schnelsen, Hamburg",
      placeLink:
        "https://www.messeninfo.de/Messehalle+Hamburg-Schnelsen-ZS19.html",
      city: "Hamburg",
      country: "Deutschland",
    },
    {
      title: "Supreme Women&Men",
      subTitle: "Ordermesse für hochwertige Damen- und Herrenmode",
      dates: "05. - 08. August 2023",
      link: "https://www.messeninfo.de/Supreme+Women%26Men-M11960/M%C3%BCnchen.html",
      thumbnail: "/images/info/events/small_248.webp",
      logo: "/images/info/events/supreme_women_men_logo_11960.webp",
      demographic: "für Fachbesucher",
      place: "MTC Münchner Textil Center, München",
      placeLink:
        "https://www.messeninfo.de/MTC+M%C3%BCnchner+Textil+Center-ZS5749.html",
      city: "München",
      country: "Deutschland",
    },
    {
      title: "Solnhofener Fossilientage",
      subTitle: "Mineralien- und Fossilienmesse",
      dates: "05. - 06. August 2023",
      link: "https://www.messeninfo.de/Solnhofener+Fossilientage-M11911/Solnhofen.html",
      thumbnail: "/images/info/events/small_127.webp",
      logo: "/images/info/events/solnhofener_fossilientage_logo_11911.webp",
      demographic: "für Fachbesucher und Privatbesucher",
      place: "Bürgermeister-Müller-Museum, Solnhofen",
      placeLink:
        "https://www.messeninfo.de/B%C3%BCrgermeister-M%C3%BCller-Museum-ZS8351.html",
      city: " Solnhofen ",
      country: "Deutschland",
    },
    {
      title: "QUARTERfashion",
      subTitle: "Fachmesse und Ordertage für Bekleidung und Accessoires",
      dates: "05. - 07. August 2023",
      link: "https://www.messeninfo.de/QUARTERfashion-M4827/Schkeuditz.html",
      thumbnail: "/images/info/events/small_46.webp",
      logo: "/images/info/events/quarterfashion_logo_4827.webp",
      demographic: "für Fachbesucher",
      place: "MMC Mitteldeutsches Mode Center, Schkeuditz",
      placeLink:
        "https://www.messeninfo.de/MMC+Mitteldeutsches+Mode+Center-ZS518.html",
      city: "Schkeuditz",
      country: "Deutschland",
    },
    {
      title: "SOC Saisoneröffnung Hannover",
      subTitle: "Ordermesse für den Schuhfachhandel",
      dates: "06. - 07. August 2023",
      link: "https://www.messeninfo.de/SOC+Saisoner%C3%B6ffnung+Hannover-M8635/Langenhagen.html",
      thumbnail: "/images/info/events/small_307.webp",
      logo: "/images/info/events/soc_saisoneroeffnung_logo_8635.webp",
      demographic: "für Fachbesucher",
      place: "Brandboxx Hannover",
      placeLink: "https://www.messeninfo.de/Brandboxx+Hannover-ZS2394.html",
      city: "Langenhagen",
      country: "Deutschland",
    },
    {
      title: "Reptilienbörse",
      subTitle: "Messe für Terraristik in der Hessenhalle der Messe Giessen",
      dates: "06. August 2023",
      link: "https://www.messeninfo.de/Reptilienb%C3%B6rse-M5857/Gie%C3%9Fen.html",
      thumbnail: "/images/info/events/small_334.webp",
      logo: "/images/info/events/reptilienmesse_logo_neu_5857.webp",
      demographic: "Publikumsmesse",
      place: "Messe Giessen",
      placeLink: "https://www.messeninfo.de/Messe+Giessen-ZS748.html",
      city: "Gießen",
      country: "Deutschland",
    },
    {
      title: "Ruhrpott-Hundemesse",
      subTitle:
        "Hundemesse mit Informationen, Angeboten, Schnäppchen und Shows rund um den Hund",
      dates: "06. August 2023",
      link: "https://www.messeninfo.de/Ruhrpott-Hundemesse-M13001/Duisburg.html",
      thumbnail: "/images/info/events/small_389.webp",
      logo: "/images/info/events/ruhrpott_hundemesse_logo_13001.webp",
      demographic: "für Fachbesucher und Privatbesucher",
      place: "Kultur- und Bürgerzentrum Steinhof, Duisburg",
      placeLink:
        "https://www.messeninfo.de/Kultur-+und+B%C3%BCrgerzentrum+Steinhof-ZS5852.html",
      city: "Duisburg",
      country: "Deutschland",
    },
    {
      title: "Antik & Trödel",
      subTitle: "Monatlicher Antik- und Trödelmarkt",
      dates: "06. August 2023 ",
      link: "https://www.messeninfo.de/Antik+%26+Tr%C3%B6del-M897/Gie%C3%9Fen.html",
      thumbnail: "/images/info/events/small_15.webp",
      logo: "/images/info/events/antik-und-troedel_logo_897.webp",
      demographic: "Publikumsmesse",
      place: "Messe Giessen",
      placeLink: "https://www.messeninfo.de/Messe+Giessen-ZS748.html",
      city: "Gießen",
      country: "Deutschland",
    },
    {
      title: "Film-Messe",
      subTitle:
        "Fachmesse für Film-Verleiher, Kinobetreiber und kinoaffine Unternehmen",
      dates: "",
      link: "https://www.messeninfo.de/Film-Messe-M5518/K%C3%B6ln.html",
      thumbnail: "/images/info/events/small_112.webp",
      logo: "/images/info/events/film_messe_koeln_logo_5518.webp",
      demographic: "für Fachbesucher",
      place: "Cinedom",
      placeLink: "https://www.messeninfo.de/Cinedom-ZS9199.html",
      city: "Köln",
      country: "Deutschland",
    },
    {
      title: "Kids & more Schuhtage Hannover",
      subTitle: "Fachmesse für Kinderschuhe",
      dates: "08. - 09. August 2023 ",
      link: "https://www.messeninfo.de/Kids+%26+more+Schuhtage+Hannover-M6262/Langenhagen.html",
      thumbnail: "/images/info/events/small_307.webp",
      logo: "/images/info/events/kids_and_more_schuhtage_logo_6262.webp",
      demographic: "für Fachbesucher",
      place: "Brandboxx Hannover",
      placeLink: "https://www.messeninfo.de/Brandboxx+Hannover-ZS2394.html",
      city: "Langenhagen",
      country: "Deutschland",
    },
  ];

  return (
    <>
      <BackButton />
      <div className="grid grid-flow-row gap-6 text-gray-700">
        <section className="relative">
          <img
            src="/images/info/projekt-auftragsvergabe-header-2.jpg"
            className="h-[300px] w-full object-cover"
          />
          <div className="absolute top-1/2 left-6 -translate-y-1/2 font-semibold italic flex flex-col">
            <div className="bg-white bg-opacity-80 text-darkcyan w-fit px-1 text-2xl">
              Kulturkarte Chemnitz
            </div>
            <div className="bg-darkblue bg-opacity-80 text-white w-fit px-1 ml-4">
              Kunst und Kultur
            </div>
          </div>
        </section>

        <h1 className="font-semibold text-base">Messen in Sachsen</h1>
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-2">
          {localEvents.map((event: PlaceType, index) => {
            return (
              <div className="grid grid-flow-row text-sm h-[260px]" key={index}>
                <NavLink to={event.link} key={index} target="_blank">
                  <div className="relative group h-[100px] shadow-lg overflow-hidden">
                    <img
                      src={event.thumbnail}
                      className="w-full h-[100px] object-cover"
                    />
                    <img
                      src={event.logo}
                      className="absolute left-5 top-0 w-[50px]"
                    />
                    <div className="absolute top-0 left-0 w-full h-full bg-opacity-[15%] transition-all group-hover:bg-opacity-0 bg-green-400"></div>
                  </div>
                  <h2 className="bg-[#add1a0] h-[32px] flex items-center pl-2">
                    {event.dates.length > 0 ? event.dates : "Kein Termin"}
                  </h2>
                </NavLink>
                <div className="font-semibold text-base mb-1 truncate">
                  {event.title}
                </div>
                <div className="text-xs line-clamp-3 h-[50px]">
                  {event.subTitle}
                </div>
                <div className="text-xs truncate">{event.demographic}</div>
                <div className="grid grid-cols-[1fr,50px] gap-2 mt-0.5">
                  <div className="grid grid-flow-row leading-4 truncate text-ellipsis">
                    <NavLink to={event.placeLink} key={index} target="_blank">
                      <div className="text-darkcyan font-semibold">
                        {event.place}
                      </div>
                    </NavLink>
                    <div>{event.city}</div>
                  </div>
                  {event.country === "Deutschland" && (
                    <img
                      src="/images/countries/de.webp"
                      className="w-[45px] h-[27px]"
                      alt={event.country}
                    />
                  )}
                </div>
              </div>
            );
          })}
        </div>

        <h1 className="font-semibold text-base">Messen bundesweit</h1>
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-2">
          {largeEvents.map((event: PlaceType, index) => {
            return (
              <div className="grid grid-flow-row text-sm h-[260px]" key={index}>
                <NavLink to={event.link} key={index} target="_blank">
                  <div className="relative group h-[100px] shadow-lg overflow-hidden">
                    <img
                      src={event.thumbnail}
                      className="w-full h-[100px] object-cover"
                    />
                    <img
                      src={event.logo}
                      className="absolute left-5 top-0 w-[50px]"
                    />
                    <div className="absolute top-0 left-0 w-full h-full bg-opacity-[15%] transition-all group-hover:bg-opacity-0 bg-green-400"></div>
                  </div>
                  <h2 className="bg-[#add1a0] h-[32px] flex items-center pl-2">
                    {event.dates.length > 0 ? event.dates : "Kein Termin"}
                  </h2>
                </NavLink>
                <div className="font-semibold text-base mb-1 truncate">
                  {event.title}
                </div>
                <div className="text-xs line-clamp-3 h-[50px]">
                  {event.subTitle}
                </div>
                <div className="text-xs truncate">{event.demographic}</div>
                <div className="grid grid-cols-[1fr,50px] gap-2 mt-0.5">
                  <div className="grid grid-flow-row leading-4 truncate text-ellipsis">
                    <NavLink to={event.placeLink} key={index} target="_blank">
                      <div className="text-darkcyan font-semibold">
                        {event.place}
                      </div>
                    </NavLink>
                    <div>{event.city}</div>
                  </div>
                  {event.country === "Deutschland" && (
                    <img
                      src="/images/countries/de.webp"
                      className="w-[45px] h-[27px]"
                      alt={event.country}
                    />
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default EventCalendar;
